import script from "./CatalogMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogMenuItem.vue?vue&type=style&index=0&id=04c60372&lang=scss"

const __exports__ = script;

export default __exports__